import { query, queryFirst, queryWithModuleId } from 'helpers/QueryHelper';
import { NotificationSettingType, NotificationType } from '../type';

type InsertNotificationApi = {
  Avatar: string;
  Title: string;
  Content: string;
  Type: NotificationType; //Gửi cho 1 người hay nhiều người
  TypeData: string; //user id hoặc role để gửi thông báo theo Type
  UserId: number;
  Setting:
    | {
        type: NotificationSettingType;
        [key: string]: any;
      }
    | '';
};
const insertNotificationApi = (parameters: InsertNotificationApi) => {
  //     @ModuleId UNIQUEIDENTIFIER,
  //     @Avatar NVARCHAR(MAX),
  //     @Title NVARCHAR(500),
  //     @Content NVARCHAR(MAX),
  //     @Type NVARCHAR(250),
  //     @TypeData NVARCHAR(250),
  //     @UserId INT
  const params = {
    ...parameters,
    Setting: JSON.stringify(parameters.Setting),
  };
  return queryWithModuleId('p_SACHSO_ThongBao_ThemMoi', params);
};

type GetNotificationListApi = {
  UserId: number;
  PageNum: number;
  PageSize: number;
};
const getNotificationListApi = (parameters: GetNotificationListApi) => {
  // (@UserId INT)  @UserId INT,
  // @PageNum INT = 1,
  // @PageSize INT = 10
  return query('p_SACHSO_ThongBao_NguoiDung_DanhSach', parameters);
};

type UpdateNotificationStatusApi = {
  UserId: number;
  ThongBaoId: number;
  TrangThai: 0 | 1;
};
const updateNotificationStatusApi = (parameters: UpdateNotificationStatusApi) => {
  //     @UserId INT,
  //     @ThongBaoId INT,
  //     @TrangThai INT = 1
  return queryFirst('p_SACHSO_ThongBao_TrangThai_CapNhat', parameters);
};

type DeleteUserNotificationApi = {
  UserId: number;
  ThongBaoId: number;
};

const deleteUserNotificationApi = (parameters: DeleteUserNotificationApi) => {
  //     @UserId INT,
  //     @ThongBaoId INT
  return queryFirst('p_SACHSO_ThongBao_NguoiDung_Xoa', parameters);
};

export { insertNotificationApi, getNotificationListApi, updateNotificationStatusApi, deleteUserNotificationApi };
